import { Box, Chip, Typography } from "@mui/material";
import DashboardLayout from "../../layout";
import DTable from "../Dashboard/Table";
import TableSearch from "shared/TableSearch";
import { useNavigate } from "react-router-dom";
import ReUseAbleTable, { Column } from "shared/ReUseAbleTable";
import StatsCardGrid from "components/StatsCardGrid";
import { rideShowUps } from "pages/Dashboard/data/data";
import { motion } from "framer-motion";

export default function BookingRide() {
  const navigate = useNavigate();

  const columns: Column[] = [
    { id: "from", label: "From", minWidth: 100 },
    { id: "to", label: "To", minWidth: 100 },
    {
      id: "eta",
      label: "ETA",
      minWidth: 100,
      format: (value: any) => (
        <Box>
          <Typography color="#344054" fontSize={14}>
            {value.date}
          </Typography>
          <Typography color="#344054" fontSize={14}>
            {value.time}
          </Typography>
        </Box>
      ),
    },

    {
      id: "status",
      label: "Status",
      minWidth: 72,
      format: (value: any) => (
        <Chip
          label={value}
          size="small"
          sx={{ bgcolor: "#E8FFF2", color: "#379E66", fontSize: "14px" }}
        />
      ),
    },
  ];

  const rows = [
    {
      id: 1,
      from: "Nnamdi  Azikwe International Airport",
      to: "Ikeja, Lagos",
      eta: { date: "7 July 2024", time: "10:00 AM" },
      status: "En Route",
    },
    {
      id: 11,
      from: "Federal Camp Otuke",
      to: "Kule, Abuja",
      eta: { date: "7 July 2024", time: "10:00 AM" },
      status: "En Route",
    },
    {
      id: 121,
      from: "Nnamdi  Azikwe International Airport",
      to: "Onitsha, Anambra",
      eta: { date: "7 July 2024", time: "10:00 AM" },
      status: "Completed",
    },
  ];
  return (
    <DashboardLayout nextSideBar>
      <Box sx={{ width: "100%" }}>
        <Box
          display="grid"
          gridTemplateColumns={{ md: "1fr 1fr 1fr", xs: "1fr" }}
          gap="30px"
        >
          {rideShowUps.map((items) => (
            <motion.button
              whileHover={{ scale: 1.0 }}
              whileTap={{ scale: 0.9 }}
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "12px",
                border: "1px solid #E4E7EC",
                padding: "16px",
              }}
            >
              <Box
                display="flex"
                alignItems="start"
                justifyContent="space-between"
              >
                <Box>
                  <Typography fontSize="16px" fontWeight={600} color="#202224">
                    {items.title}
                  </Typography>
                  <Typography mt="7px" fontSize="30px" fontWeight={700}>
                    {items.value}
                  </Typography>
                </Box>
                <Box
                  bgcolor={items.bg}
                  borderRadius="100%"
                  height="60px"
                  width="60px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    height="32.73px"
                    width="32.73px"
                    src={items.icon}
                    alt={items.title}
                  />
                </Box>
              </Box>
              <Typography
                fontSize="14px"
                fontWeight={600}
                mt="14px"
                sx={{ display: "flex", gap: "2px" }}
              >
                <img height="24px" width="24px" src={items.arrow} alt="alt" />

                <span style={{ color: items.aColor || "#379E66" }}>
                  {items.rating}%
                </span>
                <span style={{ color: "#98A2B3", fontSize: "13px" }}>
                  {items.res}
                </span>
              </Typography>
            </motion.button>
          ))}
        </Box>
        <Box mt="30px" mb="24px" display="flex" gap="10px">
          <div>
            <Typography color="#101828" fontSize="24px" fontWeight={600}>
              Manage Bookings
            </Typography>
          </div>
        </Box>

        {/* <TableSearch
          noBgColor
          p="0px"
          searchPlaceHolder="Booking ID, User, Flight/Ride ..."
        /> */}

        <ReUseAbleTable
          columns={columns}
          rows={rows}
          onClick={(row) =>
            navigate("/bookings/rideorderdetails", { state: { row } })
          }
        />
      </Box>
    </DashboardLayout>
  );
}
